import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';

import Button from '../../Button';
import Paragraph from '../../Paragraph';
import renderField from '../../Inputs';
import { getMapData } from '../../../Actions/MapData/getMapData';

class Filter extends React.PureComponent {
  state = {
    gender: '',
    ethnicity: '',
    age: '',
  }

  resetAll = () => {
    this.setState({
      gender: '',
      ethnicity: '',
      age: '',
    });
    this.props.getMapData({ gender: '', age: '', ethnicity: '' });
    this.props.closeSlide();
    this.props.updateGender(null);
    this.props.dispatch(change('campaign', 'campaign[gender_simple]', ''));
    this.props.dispatch(change('campaign', 'campaign[age]', ''));
  }

  updateMap = () => {
    // because linters
    const { gender, age, ethnicity } = this.state;
    this.props.getMapData({ gender, age, ethnicity });
    this.props.closeSlide();
    this.props.updateGender(gender);
    this.props.dispatch(change('campaign', 'campaign[gender_simple]', gender));
    this.props.dispatch(change('campaign', 'campaign[age]', age));
  }

  render() {
    const { handleSubmit, closeSlide, classes } = this.props;

    return (
      <div className={['slide-overlay', classes && classes].join(' ')}>
        <div className="slide-container">
          <form onSubmit={handleSubmit} className="form-campaign">
            <div className="slide-header">
              <Paragraph classes="header-text" center>Filter</Paragraph>
              <div className="button-group">
                <Button classes={['underline-button']} label="Reset filters" onClick={this.resetAll} />
                <Button classes={['underline-button']} label="Cancel" onClick={closeSlide} />
              </div>
            </div>
            <Field
              name="campaign[gender_simple]"
              type="select"
              params={{ dataKey: 'gender_simple', placeholder: 'Gender' }}
              component={renderField}
              onChange={(e, gender) => this.setState({ gender })}
            />
            {/* <Field
              name="campaign[ethnicity]"
              type="select"
              params={{ dataKey: 'ethnicity', placeholder: 'Ethnicity' }}
              onChange={(e, ethnicity) => this.setState({ ethnicity })}
              component={renderField}
            /> */}
            <Field
              name="campaign[age]"
              type="select"
              params={{ dataKey: 'age', placeholder: 'Age' }}
              onChange={(e, age) => this.setState({ age })}
              component={renderField}
            />
            <Button classes={['color-button orange']} label="Apply filters" onClick={this.updateMap} />
          </form>
        </div>
      </div>
    );
  }
}

Filter.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = dispatch => ({
  getMapData: p => dispatch(getMapData(p)),
});

const Form = reduxForm({
  form: 'campaign',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(Filter);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Form);



// WEBPACK FOOTER //
// ./src/Components/Campaign/FormPages/Filter.jsx